import { render, staticRenderFns } from "./CompetitionLive.vue?vue&type=template&id=10fb509c&"
import script from "./CompetitionLive.vue?vue&type=script&lang=js&"
export * from "./CompetitionLive.vue?vue&type=script&lang=js&"
import style0 from "./CompetitionLive.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports